import { Component, OnInit } from '@angular/core';
import { DepartmentBase } from '../department.base';

@Component({
  selector: 'dpto-19',
  templateUrl: './dpto19.component.html',
  styleUrls: ['../department/department.component.css']
})
export class Dpto19Component extends DepartmentBase {
  municipalities = [{
    "id": 362,
    "code": "19001",
    "name": "Popay\u00e1n",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 363,
    "code": "19022",
    "name": "Almaguer",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 364,
    "code": "19050",
    "name": "Argelia",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 365,
    "code": "19075",
    "name": "Balboa",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 366,
    "code": "19100",
    "name": "Bol\u00edvar",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 367,
    "code": "19110",
    "name": "Buenos Aires",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 368,
    "code": "19130",
    "name": "Cajib\u00edo",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 369,
    "code": "19137",
    "name": "Caldono",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 370,
    "code": "19142",
    "name": "Caloto(1)(3)",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 371,
    "code": "19212",
    "name": "Corinto",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 372,
    "code": "19256",
    "name": "El Tambo",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 373,
    "code": "19290",
    "name": "Florencia",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 374,
    "code": "19300",
    "name": "Guachen\u00e9 (1) ",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 375,
    "code": "19318",
    "name": "Guapi",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 376,
    "code": "19355",
    "name": "Inz\u00e1",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 377,
    "code": "19364",
    "name": "Jambal\u00f3",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 378,
    "code": "19392",
    "name": "La Sierra",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 379,
    "code": "19397",
    "name": "La Vega",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 380,
    "code": "19418",
    "name": "L\u00f3pez",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 381,
    "code": "19450",
    "name": "Mercaderes",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 382,
    "code": "19455",
    "name": "Miranda",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 383,
    "code": "19473",
    "name": "Morales",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 384,
    "code": "19513",
    "name": "Padilla",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 385,
    "code": "19517",
    "name": "Paez",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 386,
    "code": "19532",
    "name": "Pat\u00eda",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 387,
    "code": "19533",
    "name": "Piamonte",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 388,
    "code": "19548",
    "name": "Piendam\u00f3",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 389,
    "code": "19573",
    "name": "Puerto Tejada",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 390,
    "code": "19585",
    "name": "Purac\u00e9",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 391,
    "code": "19622",
    "name": "Rosas",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 392,
    "code": "19693",
    "name": "San Sebasti\u00e1n",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 393,
    "code": "19698",
    "name": "Santander de Quilichao",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 394,
    "code": "19701",
    "name": "Santa Rosa",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 395,
    "code": "19743",
    "name": "Silvia",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 396,
    "code": "19760",
    "name": "Sotara",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 397,
    "code": "19780",
    "name": "Su\u00e1rez",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 398,
    "code": "19785",
    "name": "Sucre",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 399,
    "code": "19807",
    "name": "Timb\u00edo",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 400,
    "code": "19809",
    "name": "Timbiqu\u00ed",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 401,
    "code": "19821",
    "name": "Toribio",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 402,
    "code": "19824",
    "name": "Totor\u00f3",
    "state": "1",
    "department_code": "19"
  }, {
    "id": 403,
    "code": "19845",
    "name": "Villa Rica",
    "state": "1",
    "department_code": "19"
  }]
}

